import type { CertificationTraining } from "../../lib/api/certifications";
import {
  getYoutubeThumbnailUrl,
  getYoutubeVideoId,
  isYoutubeUrl,
} from "../../lib/media/youtube";

const FALLBACK_IMGS = [
  "/images/certification/lesson-1.png",
  "/images/certification/lesson-2.png",
  "/images/certification/lesson-3.png",
  "/images/certification/lesson-4.png",
  "/images/certification/lesson-5.png",
  "/images/certification/lesson-6.png",
];

export function trainingPoster(
  training: CertificationTraining,
  index: number,
): string | null {
  if (training.thumbnailUrl) return training.thumbnailUrl;
  const ytId = training.videoUrl ? getYoutubeVideoId(training.videoUrl) : null;
  if (ytId) return getYoutubeThumbnailUrl(ytId);
  if (training.videoUrl && !isYoutubeUrl(training.videoUrl)) return null;
  return FALLBACK_IMGS[index % FALLBACK_IMGS.length];
}
